<template lang="pug">
    div
        div(v-if="pData.specifications")
            h3 Specifications
            div(v-if="pData.specifications.content" v-html="pData.specifications.content")
            FileList(v-if="pData.specifications.files" :files="pData.specifications.files")
            VideoList(v-if="pData.specifications.videos" :videos="pData.specifications.videos")
        div(v-if="pData.howItWorks")
            h3 How It Works
            ImageList(:data="pData.howItWorks")
        div(v-if="pData.additionalFeatures")
            h3 Additional Features
            ImageList(:data="pData.additionalFeatures")
        div(v-if="pData.faq")
            h3 Frequently Asked Questions
            div(v-if="pData.faq.content" v-html="pData.faq.content")
            FileList(v-if="pData.faq.files" :files="pData.faq.files")
            VideoList(v-if="pData.faq.videos" :videos="pData.faq.videos")
</template>

<script>
import ImageList from './imageList'
import FileList from './fileList'
import VideoList from './videoList'

export default {
    components: {
        ImageList,
        FileList,
        VideoList,
    },
    computed: {
        pData() {
            return this.$store.state.product.data
        },
    },
}
</script>
